export default "__VITE_ASSET__BmDeCB_4__"